module.exports = {
  PARKING: 'parking',
  ADVERTISING: 'advertising',
};
